import { useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import './../../scss/components/bar-chart.style.scss';
import { useAnalysis } from '../../hooks/useAnalysis';
import { useAppDispatch } from '../../hooks/useRedux';
import { fetchAnalysisAsync } from '../../features/analysis/analysis.slice';
import { useTranslation } from 'react-i18next';
import { NoChartsyet } from './no-invoices-yet.component';
import { useUserDashboard } from '../../hooks/useUserDashboard';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const DATA_COUNT = 7;
const NUMBER_CFG = { count: DATA_COUNT, min: -100, max: 100 };

const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'bottom' as const,
      labels: {
        font: {
          family: 'Plus Jakarta Sans',
          size: 12,
          weight: 500,
        },
        color: '#252525',
        usePointStyle: true,
      },
    },
    title: {
      display: true,
      // text: 'Fakturaanalys',
      font: {
        family: 'Plus Jakarta Sans',
        size: 16,
        weight: 700,
      },
      color: '#252525',
    },
    tooltip: {
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      titleColor: '#ffffff',
      bodyColor: '#ffffff',
      borderColor: '#374151',
      borderWidth: 1,
      cornerRadius: 8,
      displayColors: true,
    },
  },
  scales: {
    x: {
      grid: {
        display: false,
      },
      ticks: {
        font: {
          family: 'Plus Jakarta Sans',
          size: 11,
        },
        color: '#6B7280',
      },
    },
    y: {
      beginAtZero: true,
      grid: {
        color: '#E5E7EB',
      },
      ticks: {
        font: {
          family: 'Plus Jakarta Sans',
          size: 11,
        },
        color: '#6B7280',
      },
    },
  },
  elements: {
    bar: {
      borderRadius: 4,
      borderSkipped: false,
    },
  },
};



export const BarChart = () => {

  const { analysisData, loading, error } = useAnalysis();
  const {
    dashboardData,
  } = useUserDashboard();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(fetchAnalysisAsync());
  }, []);

  const currentYear = new Date().getFullYear();
  const year1 = currentYear - 1;
  const year2 = currentYear;
  const mappedData = {
    labels: analysisData?.response.data?.map((item) => t(item.month)),
    datasets: [
      {
        label: `${year1}`,
        data: analysisData?.response.data?.map((item) => item.year1Amount),
        borderColor: '#aaa1d2',
        backgroundColor: 'rgba(170, 161, 210, 0.5)',
      },
      {
        label: `${year2}`,
        data: analysisData?.response.data?.map((item) => item.year2Amount),
        borderColor: '#6750b8',
        backgroundColor: 'rgba(103, 80, 184, 0.5)',
      },
    ],
  };
  return (
    <div className="bar-chart-container">
      <div className='d-flex justify-content-between align-items-center overflow-y-scroll '>
        <div>
          <h2 className='mb-0' style={{ fontSize: '22px', fontWeight: '700', color: '#252525' }}>{t('INVOICE_ANALYSIS')}</h2>
          <p>{t('INCOME_TRENDS_WILL_SHOW_ONCE_YOU_START_INVOICING')}</p>
        </div>
      </div>
      {Number(dashboardData?.response.length) === 0 ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            width: '100%',
            overflowX: 'auto',
            overflowY: 'hidden',
          }}
        >
          <NoChartsyet />
        </div>
      ) : (
        <Bar data={mappedData} options={options} />
      )}
    </div>
  );
};
